import React from 'react';

import { ProductInformationSliderContainer } from 'Components/widgets/product-information-slider/ProductInformationSlider.container.jsx';
import { TeaserCardsCard } from './teaser-cards-card/TeaserCardsCard.jsx';
import { TeaserCardsLayer } from './teaser-cards-layer/TeaserCardsLayer.jsx';

export function resolveLayerData(cardData) {
  const { image, layerTitle: title, layerDescription: description, layerBlocks: blocks } = cardData;
  return Promise.resolve({
    image,
    title,
    description,
    blocks,
  });
}

export const TeaserCards = props => {
  const {
    cards = [],
    backNavigationLabel,
    scrollBackwardLabel,
    scrollForwardLabel,
    sliderQueryName,
  } = props;

  return (
    <ProductInformationSliderContainer
      backNavigationLabel={backNavigationLabel}
      isExpanded
      queryLayer={sliderQueryName}
      renderDetail={layerData => <TeaserCardsLayer {...layerData} />}
      scrollBackwardLabel={scrollBackwardLabel}
      scrollForwardLabel={scrollForwardLabel}
      sliderIndex={1}
    >
      {cards.map((card, index) => (
        <TeaserCardsCard
          card={card}
          fetchDetail={() => resolveLayerData(card)}
          key={index}
          link={card.link} // Component takes card link as separate prop so it can be cloned with a slider link
          trackingData={card.trackingData}
        />
      ))}
    </ProductInformationSliderContainer>
  );
};
